var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_c('div',{staticClass:"text-center col-sm-12"},[_c('h1',[_vm._v("You are lost.")]),_c('h4',[_vm._v("This page doesn't exist.")]),_c('router-link',{staticClass:"vertical-5p lead",attrs:{"to":"/"}},[_vm._v(" Take me home. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }